import { call, put, takeEvery } from "redux-saga/effects"
import toast from "toastr"
import { togglePageLoader } from "store/actions"
import { getReportSubmittedTime } from "helpers/backend_helper"
import { GET_REPORT_SUBMITTED_TIME } from "./actionTypes"
import {
  getReportSubmittedTimeSuccess,
  getReportSubmittedTimeError,
} from "./action"

function* getReportSubmittedTimeList({ payload: params, exports }) {
  try {
    yield put(togglePageLoader(true))
    const response = yield call(getReportSubmittedTime, params)
    if (exports !== "export") {
      if (response.statusCode === 200) {
        yield put(getReportSubmittedTimeSuccess(response))
      } else {
        yield put(getReportSubmittedTimeError(response))
        toast.error(response.message)
      }
    }
    yield put(togglePageLoader(false))
  } catch (error) {
    yield put(getReportSubmittedTimeError(error))
    toast.error(error?.response ? error.response?.data?.message : error)
    yield put(togglePageLoader(false))
  }
}

function* reportSubmittedTimeSaga() {
  yield takeEvery(GET_REPORT_SUBMITTED_TIME, getReportSubmittedTimeList)
}

export default reportSubmittedTimeSaga
